import * as React from 'react'
import ga4analyticsClient from '@/scopes/common/infrastructure/analytics/ga4analyticsClient'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { createLocation } from '@/scopes/common/infrastructure/dom/location'
import { createNewRelicLogger } from '@/scopes/common/infrastructure/logging/newRelicLogger'
import { createPaymentActions } from '@/scopes/payment/domain/actions'
import { PaymentActionsProvider, usePaymentContext, usePaymentStep } from '@/scopes/payment/domain/PaymentContext'
import { createPaymentApiClient } from '@/scopes/payment/infrastructure/paymentApiClient'
import { paymentStore } from '@/scopes/payment/infrastructure/store'
import { voucherStore } from '@/scopes/payment/infrastructure/vouchers/store'

export function PaymentActionsDependenciesProvider({ children }: React.PropsWithChildren) {
  const { contextItemId, groupUserId, bookingNumber, scope } = usePaymentContext()
  const { goToAmounts, goToMethods } = usePaymentStep()
  const siteName = useConfiguration('siteName')

  const actions = React.useMemo(
    () =>
      createPaymentActions({
        apiClient: createPaymentApiClient({
          contextItemId,
          groupUserId,
        }),
        store: paymentStore,
        location: createLocation(),
        logger: createNewRelicLogger({ scope: 'payment' }),
        siteName,
        scope,
        bookingNumber,
        resetVoucher: voucherStore.getState().reset,
        analyticsClient: ga4analyticsClient,
        goToAmounts,
        goToMethods,
      }),
    [bookingNumber, contextItemId, goToAmounts, goToMethods, groupUserId, scope, siteName],
  )

  return <PaymentActionsProvider actions={actions}>{children}</PaymentActionsProvider>
}
